document.addEventListener('DOMContentLoaded', function() {
  const collapsibleSections = document.querySelectorAll('.section-collapsible-content');

  collapsibleSections.forEach(section => {
    const collapsibleItems = section.querySelectorAll('.collapsible-item');

    collapsibleItems.forEach((item, index) => {
      const header = item.querySelector('.collapsible-item__header');
      const content = item.querySelector('.collapsible-item__content');
      const icon = item.querySelector('.collapsible-item__icon');
      if (index === 0) {
        item.setAttribute('aria-expanded', 'true');
        content.hidden = false;
        icon.textContent = '-';
      }
      header.addEventListener('click', () => {
        const isExpanded = item.getAttribute('aria-expanded') === 'true';

        item.setAttribute('aria-expanded', !isExpanded);
        content.hidden = isExpanded;
        icon.textContent = isExpanded ? '+' : '-';

        // Close other open items
        collapsibleItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.getAttribute('aria-expanded') === 'true') {
            otherItem.setAttribute('aria-expanded', 'false');
            otherItem.querySelector('.collapsible-item__content').hidden = true;
            otherItem.querySelector('.collapsible-item__icon').textContent = '+';
          }
        });
      });
    });
  });
});